import { useQuery } from '@tanstack/react-query'
import productDummy from '../../dataContainer/productViewData.json'
import productCommentsDummy from '../../dataContainer/productComments.json'
import { ProductComments, ProductProps } from './Types'

//TODO: update me, when api will be written
const getProduct = (): Promise<ProductProps> => {
  return Promise.resolve(productDummy)
}

export const useGetProductQuery = (id: number) => {
  return useQuery<ProductProps, { message: string }>(['productPage'], getProduct)
}

const getProductComments = (): Promise<ProductComments> => {
  return Promise.resolve(productCommentsDummy)
}

export const useProductCommentsQuery = (id: number, pageIndex: number) => {
  return useQuery<ProductComments, { message: string }>(['productComments'], getProductComments)
}
